import React, { useCallback, useState } from "react";
import { Alert, IconButton, Snackbar } from "@mui/material";
import VisibilityIcon from "@mui/icons-material/Visibility";
import VisibilityOffIcon from "@mui/icons-material/VisibilityOff";
import { useLoginUser } from "./useLoginUser";
import {
  BERLIN_LOGO_LOCAL,
  BERLIN_LOGO_URL,
} from "../../constants/brandAssets";
import logoFallback from "../../assets/Images/element-wordmark-black.svg";
import heroDashboard from "../../assets/Images/login-dashboard-preview.png";
import {
  ForgotLink,
  FormInner,
  FormSection,
  HeroContent,
  HeroHeadline,
  HeroImageWrap,
  LeftPanel,
  LoginPage,
  LoginTextField,
  LogoBar,
  RightPanel,
  SignInButton,
  WelcomeTitle,
} from "./style";

const LogIn = () => {
  const { showPassword, alert, formik, handleClose, handleEyeButton } =
    useLoginUser();
  const [logoSrc, setLogoSrc] = useState(BERLIN_LOGO_URL);

  const handleLogoError = useCallback(() => {
    setLogoSrc((current) => {
      if (current === BERLIN_LOGO_URL) return BERLIN_LOGO_LOCAL;
      if (current === BERLIN_LOGO_LOCAL) return logoFallback;
      return current;
    });
  }, []);

  return (
    <LoginPage>
      <Snackbar
        open={alert.open}
        autoHideDuration={3000}
        onClose={handleClose}
        anchorOrigin={{ vertical: "top", horizontal: "center" }}
      >
        <Alert
          onClose={handleClose}
          severity={alert.severity}
          sx={{ width: "100%" }}
        >
          {alert.message}
        </Alert>
      </Snackbar>

      <LeftPanel>
        <LogoBar>
          <img
            className="login-logo"
            src={logoSrc}
            alt="Berlin"
            onError={handleLogoError}
          />
        </LogoBar>

        <FormSection>
          <FormInner>
            <WelcomeTitle>Welcome back!</WelcomeTitle>

            <form onSubmit={formik.handleSubmit}>
              <LoginTextField
                id="email"
                name="email"
                variant="outlined"
                fullWidth
                placeholder="Email"
                value={formik.values.email}
                onChange={formik.handleChange}
                error={formik.touched.email && Boolean(formik.errors.email)}
                helperText={formik.touched.email && formik.errors.email}
              />
              <LoginTextField
                id="password"
                name="password"
                variant="outlined"
                fullWidth
                placeholder="Password"
                type={showPassword ? "text" : "password"}
                onChange={formik.handleChange}
                value={formik.values.password}
                error={
                  formik.touched.password && Boolean(formik.errors.password)
                }
                helperText={formik.touched.password && formik.errors.password}
                InputProps={{
                  endAdornment: (
                    <IconButton
                      onClick={handleEyeButton}
                      edge="end"
                      aria-label="toggle password visibility"
                      sx={{ color: "#6b7280" }}
                    >
                      {showPassword ? <VisibilityOffIcon /> : <VisibilityIcon />}
                    </IconButton>
                  ),
                }}
              />
              <SignInButton variant="contained" fullWidth type="submit">
                Sign in
              </SignInButton>
              <ForgotLink to="/forgot-password">
                Forgot password?
              </ForgotLink>
            </form>
          </FormInner>
        </FormSection>
      </LeftPanel>

      <RightPanel>
        <HeroContent>
          <HeroHeadline>
            Total visibility.
            <br />
            Every client, requirement,
            <br />
            and hire — in one place.
          </HeroHeadline>
          <HeroImageWrap>
            <img src={heroDashboard} alt="Berlin Jobs dashboard preview" />
          </HeroImageWrap>
        </HeroContent>
      </RightPanel>
    </LoginPage>
  );
};

export default LogIn;
